import { createFileRoute } from '@tanstack/react-router'

import { WebhooksSettingsPage } from '@/features/integrations/webhooks-settings-page'

export const Route = createFileRoute('/_app/integracoes/webhooks/')({
  component: WebhooksSettingsPage,
})
